import React, {useEffect, useState} from "react";
import styles from './PromoSaleType.module.scss'
import {ReactComponent as EditIcon} from '../../../../assets/promo_sale_types_icons/edit_icon.svg'

import {DefaultSaleTypeDto, PromoDto, SaleTypeDto} from "../../../../dtos";

interface Props {
    saleType: SaleTypeDto;
    defaultSaleType?: DefaultSaleTypeDto;
    isSelected: boolean;
    setSelectedSaleTypeData: (saleType: SaleTypeDto) => void;
    requisiteMaxValue?: number;
    requisiteMinValue?: number;
}


export const PromoSaleType: React.FC<Props> = (
    {
        saleType,
        defaultSaleType,
        isSelected,
        setSelectedSaleTypeData,
        requisiteMaxValue,
        requisiteMinValue
    }
) => {
    const [requisiteValue, setRequisiteValue] = useState<string>('');
    const [benefitValue, setBenefitValue] = useState<string>('');


    const [isEditRequisite, setEditRequisite] = useState<boolean>(false);
    const [isEditBenefit, setEditBenefit] = useState<boolean>(false);

    const [isSelectedSaleType, setSelectedSaleType] = useState<boolean>(false);

    useEffect(() => {
        setRequisiteValue(saleType.requisite ? saleType.requisite : defaultSaleType?.saleTypeData.defaultRequisite);
        setBenefitValue(saleType.benefit ? saleType.benefit : defaultSaleType?.saleTypeData.defaultBenefit);

    }, []);

    useEffect(() => {
        setSelectedSaleType(isSelected);
    }, [isSelected])

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const invalidChars = ["-", "+", "e", "E"]; //include "." if you only want integers
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
            return;
        }
    }


    const onEditRequisite = () => {
        setEditRequisite(!isEditRequisite);
        onClickRow();
    };

    const onEditBenefit = () => {
        setEditBenefit(!isEditBenefit);
        onClickRow();
    }

    const onChangeRequisite = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;
        if (currentValue.indexOf('.') > -1) {
            if (currentValue.indexOf('.') + 3 >= currentValue.length) {
                if(requisiteMaxValue && Number(currentValue) > requisiteMaxValue){
                    setRequisiteValue(requisiteMaxValue.toString());
                // } else if(requisiteMinValue && Number(currentValue) < requisiteMinValue){
                //     setRequisiteValue(requisiteMinValue.toString());
                } else {
                    setRequisiteValue(currentValue)
                }
            }
        } else {
            if(requisiteMaxValue && Number(currentValue) > requisiteMaxValue){
                setRequisiteValue(requisiteMaxValue.toString());
            // } else if(requisiteMinValue && Number(currentValue) < requisiteMinValue){
            //     setRequisiteValue(requisiteMinValue.toString());
            } else {
                setRequisiteValue(currentValue)
            }
        }
    }
    const onChangeBenefit = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;
        if (currentValue.indexOf('.') > -1) {
            if (currentValue.indexOf('.') + 3 >= currentValue.length) {
                setBenefitValue(currentValue)
            }
        } else {
            setBenefitValue(currentValue)
        }
    }

    const onClickRow = () => {
        let requisiteVal: number = Number(requisiteValue);
        let benefitVal: number = Number(benefitValue);
        if(requisiteMinValue && requisiteVal < requisiteMinValue){
            requisiteVal = requisiteMinValue;
        } else if (requisiteMaxValue && requisiteVal > requisiteMaxValue){
            requisiteVal = requisiteMaxValue;
        }
        setRequisiteValue(requisiteVal.toString());
        setBenefitValue(benefitVal.toString());
        setSelectedSaleTypeData({
            ...saleType,
            requisite: requisiteVal,
            benefit: benefitVal
        })
    }
    return (
        <tr className={`${styles.sale_type_row} ${isSelectedSaleType ? styles.selected_row : ''}`} onClick={onClickRow}>
            <td>
                <div className={`${styles.content_cell_wrapper} ${
                    (defaultSaleType?.saleTypeData.defaultRequisite !== Number(requisiteValue) ||
                        defaultSaleType?.saleTypeData.defaultBenefit !== Number(benefitValue))
                        ? styles.disabledSaleTypeIcon
                        : ''}`}>
                    <img src={defaultSaleType?.saleTypeData.imageSrc} alt=""/>
                </div>
            </td>
            <td>
                <div className={styles.content_cell_wrapper}>
                    {saleType.satCode}
                </div>
            </td>
            <td>
                <div className={styles.content_cell_wrapper}>
                    {saleType.satCaption}
                </div>
            </td>
            <td>
                {
                    saleType.satCode !== 1 && <div className={styles.content_cell_wrapper}>
                        <div className={styles.caption_for_requisite_benefit}>
                            {defaultSaleType?.saleTypeData.nameRequisite}
                        </div>
                        <div className={styles.content_wrapper_for_requisite_benefit}>
                            {/*{*/}
                            {/*    requisiteValue &&*/}
                            <input type="number" className={styles.sale_type_input} readOnly={!isEditRequisite}
                                   onKeyDown={onKeyDown}
                                   title={requisiteValue}
                                   value={requisiteValue}
                                   onChange={onChangeRequisite}
                            />
                            {/*}*/}

                            {
                                defaultSaleType?.saleTypeData.isChangeableRequisite && !isEditRequisite &&
                                <div className={styles.edit_icon} onClick={onEditRequisite}>
                                    <EditIcon/>
                                </div>
                            }
                            {
                                defaultSaleType?.saleTypeData.isChangeableRequisite && isEditRequisite &&
                                <button onClick={onEditRequisite}>ok</button>
                            }

                        </div>

                    </div>

                }
            </td>
            <td>
                {
                    saleType.satCode !== 1 && <div className={styles.content_cell_wrapper}>
                        <div className={styles.caption_for_requisite_benefit}>
                            {defaultSaleType?.saleTypeData.nameBenefit}
                        </div>
                        <div className={styles.content_wrapper_for_requisite_benefit}>
                            {/*{*/}
                            {/*    benefitValue && */}
                            <input
                                title={benefitValue}
                                onKeyDown={onKeyDown}
                                type="number" className={styles.sale_type_input} readOnly={!isEditBenefit}
                                onChange={onChangeBenefit}
                                value={benefitValue}/>

                            {/*}*/}
                            {
                                defaultSaleType?.saleTypeData.isChangeableBenefit && !isEditBenefit &&
                                <div className={styles.edit_icon} onClick={onEditBenefit}>
                                    <EditIcon/>
                                </div>
                            }

                            {
                                defaultSaleType?.saleTypeData.isChangeableBenefit && isEditBenefit &&
                                <button onClick={onEditBenefit}>ok</button>
                            }
                        </div>
                    </div>

                }
            </td>

        </tr>
    )
}